<template>
  <div class="inter-wrapper">
    <HeaderInter back-path="/user/info" />
    <div class="inter-content">
      <div v-if="$store.getters.memberInfo" class="orderinit-area container-fluid">
        <div class="order-area">
          <div class="form-area mb-3">
            <input
              v-model="form.name"
              v-validate="'required|min:2'"
              type="text"
              class="box"
              :placeholder="$langt('姓名')"
              name="name"
              :data-vv-as="$langt('姓名')"
            >
            <div v-if="errors.has('name')" class="help-block">
              {{ errors.first('name') }}
            </div>
            <div class="form-item__phone-wrap">
              <select v-model="form.phone_type" class="phone-select">
                <option v-for="item in phoneOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </option>
              </select>
              <div>
                <input v-if="form.phone_type === 1" :value="countryCodeDefaultText" type="text" class="box country-code" :placeholder="$langt('國碼')" disabled>
                <template v-if="form.phone_type === 2">
                  <input
                    v-model="form.country_code"
                    v-validate="'required'"
                    type="text"
                    class="box country-code"
                    name="country_code"
                    :placeholder="$langt('國碼')"
                    :data-vv-as="$langt('國碼')"
                  >
                  <div v-if="errors.has('country_code')" class="help-block">
                    {{ errors.first('country_code') }}
                  </div>
                </template>
              </div>
              <div class="phone-input-wrap">
                <input
                  v-model="form.phone"
                  v-validate="'required'"
                  type="tel"
                  class="box"
                  name="phone"
                  :placeholder="$langt('聯絡電話')"
                  :data-vv-as="$langt('聯絡電話')"
                >
                <div v-if="errors.has('phone')" class="help-block">
                  {{ errors.first('phone') }}
                </div>
              </div>
            </div>

            <input
              v-model="form.email"
              v-validate="'required'"
              type="text"
              class="box"
              name="email"
              :data-vv-as="$langt('電子信箱')"
              :placeholder="$langt('電子信箱')"
            >
            <div v-if="errors.has('email')" class="help-block">
              {{ errors.first('email') }}
            </div>
          </div>
          <div class="btn-area px-3">
            <button class="btn btn-next" type="button" @click="submit()">
              {{ $langt('確認送出') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInter from '@/components/HeaderInter'
import { editMember } from '@/api/user'
import { showNotice } from '@/utils/tool'

export default {
  name: 'UserEdit',
  components: {
    HeaderInter
  },
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone: null,
        phone_type: 1,
        country_code: ''
      }
    }
  },
  computed: {
    phoneOptions() {
      return [
        {
          label: this.$store.getters.shopInfo.country_name || '',
          value: 1
        },
        {
          label: 'other',
          value: 2
        }
      ]
    },
    countryCodeDefaultText() {
      const { country_code } = this.$store.getters.shopInfo
      return country_code
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    submit() {
      const self = this
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          const payload = {
            ...this.form
          }
          if (this.form.phone_type === 1) {
            payload.country_code = this.$store.getters.shopInfo.country_code
          }

          editMember(payload)
            .then(response => {
              self.$store.commit('SET_MEMBER_INFO', response.data.data)
              if(response.data.msg === 'success'){
                showNotice(this.$langt('資料已更新'), function() {
                    self.$router.push({ path: '/user/info' }).catch(() => {
                  })
                })
              }

            })
            .catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "assets/scss/common.scss";

.form-item__phone-wrap {
  display: flex;
  align-items: center;
  gap: 12px;

  .phone-select {
    width: 100px;
  }

  .country-code {
    $width: 100px;
    width: $width;

    &:focus {
      width: $width;
    }
    &:disabled {
      cursor: not-allowed;
    }
  }

  .phone-input-wrap {
    width: 100%;
  }
}
</style>
